import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export interface BulkActionBarProps {
  selectedCount: number;
  onSetStatus: (anchor: HTMLElement) => void;
  onAddTags: (anchor: HTMLElement) => void;
  onRemove: () => void;
  onClear: () => void;
}

export const BulkActionBar: React.FC<BulkActionBarProps> = ({
  selectedCount,
  onSetStatus,
  onAddTags,
  onRemove,
  onClear,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <Chip
      label={`${selectedCount} selected`}
      size="small"
      sx={(theme) => ({
        backgroundColor: theme.palette.brand.cyan,
        color: 'white',
        fontWeight: 700,
        mr: 0.5,
      })}
    />
    <Button
      size="small"
      variant="outlined"
      onClick={(e) => onSetStatus(e.currentTarget)}
      endIcon={<ArrowDropDownIcon />}
    >
      Set status
    </Button>
    <Button
      size="small"
      variant="outlined"
      onClick={(e) => onAddTags(e.currentTarget)}
      endIcon={<ArrowDropDownIcon />}
    >
      Add tags
    </Button>
    <Button size="small" variant="outlined" color="error" onClick={onRemove}>
      Remove
    </Button>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ cursor: 'pointer', ml: 0.5, '&:hover': { color: 'text.primary' } }}
      onClick={onClear}
    >
      Clear
    </Typography>
  </Box>
);
